import { useContext } from 'react'

import PropTypes from 'prop-types'

import FirstPaintGateContext from '../FirstPaintGateContext'


/**
 * Withholds `children` until the <IntlProvider> above it reports that the
 * copy they will paint with is settled, so their first painted frame is
 * their final geometry.
 *
 * Place this around the copy itself rather than around the whole tree.
 * Anything above it keeps rendering while the wait is on, which is what a
 * provider that fetches but paints nothing needs: gating it too would put
 * its request in series behind the wait instead of alongside it.
 *
 * A provider that was never asked to wait reports ready, so this renders
 * immediately outside a gated tree.
 *
 * @param {Object} props
 * @param {React.ReactNode} [props.children]
 */
export default function FirstPaintGate({ children }) {
  const areChildrenReady = useContext(FirstPaintGateContext)

  if ( areChildrenReady ) {
    return children
  }

  return null
}

FirstPaintGate.propTypes = {
  children: PropTypes.node,
}
